<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <room-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      />
    </template>
  </generic-update>
</template>

<script>
import RoomForm from "./Form"
import model from "./model"

export default {
  components: { RoomForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
}
</script>
